<template>
  <div class="footer">
    <div style="background-color: rgb(79 64 125)" class="footer--bg"></div>
    <div class="footer--inner">
      <div class="am-g">
        <div class="am-u-md-1"></div>
        <div class="am-u-md-7">
          <div class="footer_main--column">
            <strong class="footer_main--column_title">关于我们</strong>
            <div class="footer_about">
              <p class="footer_about--text">
                {{ companyInfo.introduction }}
              </p>
            </div>
          </div>
        </div>
        <div class="am-u-md-3">
          <div class="footer_main--column">
            <strong class="footer_main--column_title">联系我们</strong>
            <ul class="footer_contact_info" v-if="companyInfo">
              <li class="footer_contact_info--item" v-if="companyInfo.phone">
                <i class="am-icon-phone"></i><span>{{ companyInfo.phone }}</span>
              </li>
              <li class="footer_contact_info--item" v-if="companyInfo.mailbox">
                <i class="am-icon-comment"></i><span>{{ companyInfo.mailbox }}</span>
              </li>
              <li class="footer_contact_info--item" v-if="companyInfo.address">
                <i class="am-icon-map-marker"></i><span>{{ companyInfo.address }}</span>
              </li>
              <li class="footer_contact_info--item" v-if="companyInfo.workTime">
                <i class="am-icon-clock-o"></i><span>{{ companyInfo.workTime }} </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <section class="footer_section" v-if="friendlyLinks && friendlyLinks.length > 0">
        <p>
          <a style="font-size: 18px; pointer-events: none">友情链接</a>
          <a v-for="(item, index) in friendlyLinks" :key="index" target="_blank" :href="item.url"
            style="margin-left: 25px; font-size: 16px">{{ item.title }}</a>
        </p>
      </section>
      <div class="bottom_icp">
        备案号：<a class="icp" href="https://beian.miit.gov.cn/" target="_blank">{{ companyInfo.icp }}</a><a
          v-if="companyInfo.recordCode" style="margin-left: 15px" class="icp" :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=' +
            companyInfo.recordCode
            " target="_blank">{{ companyInfo.recordName }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { getCompany, getFriendlyLinks } from "@/api/api";
export default {
  name: "Footer",
  data() {
    return {
      companyInfo: {},
      friendlyLinks: []
    };
  },
  mounted() {
    this.getCompanyInfo();
    this.getLinks();
  },
  methods: {
    getCompanyInfo() {
      getCompany().then(resp => {
        if (resp) {
          this.companyInfo = resp.data.data;
        }
      });
    },
    getLinks() {
      getFriendlyLinks().then(resp => {
        if (resp) {
          this.friendlyLinks = resp.data.data;
        }
      });
    }
  }
};
</script>

<style scoped>
.icp {
  color: #ffffff;
}

.icp:hover {
  cursor: default;
  color: #ff2600;
}

.footer_section {
  display: flex;
  justify-content: center;
  align-content: center;
  padding-top: 30px;
  padding-bottom: 15px;
}

.footer_section a {
  color: rgb(0, 255, 85);
}

.bottom_icp {
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 15px;
}
</style>
